/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function ExploreLoadedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeExploreLoadedAction } action: action de
 *     l'application
 * @return { Reducer }
 */
export const ExploreLoadedReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeExploreLoadedAction) => {
      switch (action.type) {
        case actions.ExploreLoadedActionTypes.EXPLORELOADED_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.ExploreLoadedActionTypes.EXPLORELOADED_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.ExploreLoadedActionTypes.EXPLORELOADED_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        case actions.ExploreLoadedActionTypes.EXPLORELOADED_RESET:

          return {
            state: {}
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/explorer/home/index.ts